import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from '../layouts/AdminLayout';
import { useAuth } from '../contexts/AuthContext';
import AuthGuard from '../contexts/AuthGuard';
import Dashboard from '../pages/modules/admin/dashboard/Dashboard';
import FOS from '../pages/modules/admin/user-management/FOS/FOS';
import Retailers from '../pages/modules/admin/user-management/Retailers/Retailers';
import Restaurant from '../pages/modules/admin/user-management/Restaurant/Restaurant';
import BranchManagement from '../pages/modules/admin/user-management/BranchManagement/BranchManagement';
import KitchenManagement from '../pages/modules/admin/user-management/KitchenManagement/KitchenManagement';
import DeliveryManagement from '../pages/modules/admin/user-management/DeliveryManagement/DeliveryManagement';
import CashierManagement from '../pages/modules/admin/user-management/CashierManagement/CashierManagement';
import MenuCategory from '../pages/modules/admin/menu-management/MenuCategory/MenuCategory';
import MenuSubcategory from '../pages/modules/admin/menu-management/MenuSubcategory/MenuSubcategory';
import Section from '../pages/modules/admin/menu-management/Section/Section';
import DiningTables from '../pages/modules/admin/menu-management/DiningTables/DiningTables';
import MenuItems from '../pages/modules/admin/menu-management/MenuItems/MenuItems';
import MenuItemsBulkUpdate from '../pages/modules/admin/menu-management/MenuItems/MenuItemsBulkUpdate';
import Addons from '../pages/modules/admin/menu-management/Addons/Addons';
import DeliveryZones from '../pages/modules/admin/menu-management/DeliveryZones/DeliveryZones';
import RestaurantHours from '../pages/modules/admin/menu-management/RestaurantHours/RestaurantHours';

// Order Management Components
import OrderList from '../pages/modules/admin/orders/OrderList/OrderList';
import NewOrders from '../pages/modules/admin/orders/NewOrders/NewOrders';
import Preparing from '../pages/modules/admin/orders/Preparing/Preparing';
import Onway from '../pages/modules/admin/orders/Onway/Onway';
import Delivered from '../pages/modules/admin/orders/Delivered/Delivered';
import CancelledOrders from '../pages/modules/admin/orders/CancelledOrders/CancelledOrders';

const AdminRoutes = () => {
  const { logout } = useAuth();

  return (
    <AuthGuard>
      <Routes>
        <Route element={<AdminLayout onLogout={logout} />}>
        <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />

        {/* Admin Module Routes */}
        <Route path="/admin/dashboard" element={<Dashboard />} />
        <Route path="/admin/user-management/fos" element={<FOS />} />
        <Route path="/admin/user-management/retailers" element={<Retailers />} />
        <Route path="/admin/user-management/restaurants" element={<Restaurant />} />
        <Route path="/admin/user-management/branches" element={<BranchManagement />} />
        <Route path="/admin/user-management/kitchen" element={<KitchenManagement />} />
        <Route path="/admin/user-management/delivery" element={<DeliveryManagement />} />
        <Route path="/admin/user-management/cashier" element={<CashierManagement />} />
        <Route path="/admin/menu-management/categories" element={<MenuCategory />} />
        <Route path="/admin/menu-management/subcategories" element={<MenuSubcategory />} />
        <Route path="/admin/menu-management/sections" element={<Section />} />
        <Route path="/admin/menu-management/dining-tables" element={<DiningTables />} />
        <Route path="/admin/menu-management/items" element={<MenuItems />} />
        <Route path="/admin/menu-management/items-bulk-update" element={<MenuItemsBulkUpdate />} />
        <Route path="/admin/menu-management/addons" element={<Addons />} />
        <Route path="/admin/menu-management/delivery-zones" element={<DeliveryZones />} />
        <Route path="/admin/menu-management/restaurant-hours" element={<RestaurantHours />} />

        {/* Order Management Routes */}
        <Route path="/admin/orders/list" element={<OrderList />} />
        <Route path="/admin/orders/new" element={<NewOrders />} />
        <Route path="/admin/orders/preparing" element={<Preparing />} />
        <Route path="/admin/orders/onway" element={<Onway />} />
        <Route path="/admin/orders/delivered" element={<Delivered />} />
        <Route path="/admin/orders/cancelled" element={<CancelledOrders />} />

        <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
      </Route>
    </Routes>
    </AuthGuard>
  );
};

export default AdminRoutes;

